import { JITSI_BASE_URL } from '../config';
import { buildRoomSlug } from './translit';

/**
 * Build a Jitsi Meet invite URL from a human room name and a flat params object.
 * Returns an empty string if the slug is empty (caller should treat as invalid).
 *
 * @param {string} roomName raw user-entered room name.
 * @param {Record<string, string>} params { configKey: value } map — appended as #config.key=value.
 */
export function buildInviteLink(roomName, params) {
  const slug = buildRoomSlug(roomName);
  if (!slug) return '';
  const query = Object.entries(params || {})
    .map(([k, v]) => `config.${k}=${encodeURIComponent(v)}`)
    .join('&');
  return `${JITSI_BASE_URL}/${encodeURIComponent(slug)}${query ? '#' + query : ''}`;
}
